/* Andrea: silent viewport previews; original video loads only after a tap. */
(() => {
  if (window.AndreaInlineVideo) { window.AndreaInlineVideo.scan(); return; }
  const players = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let dialog, fullVideo, fullLink, fullError, opener;
  const canPlay = state => state.visible && !state.userPaused && !document.hidden && !(dialog && dialog.open) && state.root.isConnected;
  function update(state) {
    if (!canPlay(state)) { state.video.pause(); return; }
    if (!state.video.hasAttribute('src')) {
      state.video.src = state.video.dataset.previewSrc;
      state.video.load();
    }
    state.video.muted = true;
    state.video.defaultMuted = true;
    const attempt = state.video.play();
    if (attempt) attempt.then(() => { if (!canPlay(state)) state.video.pause(); }).catch(() => {
      if (canPlay(state)) { state.root.dataset.playback = 'manual'; state.toggle.setAttribute('aria-label', 'Reproducir vista previa'); state.toggle.firstElementChild.textContent = '▷'; }
    });
  }
  function updateAll() { players.forEach(update); }
  function setPaused(state, paused) {
    state.userPaused = paused;
    state.toggle.setAttribute('aria-pressed', String(paused));
    state.toggle.setAttribute('aria-label', paused ? 'Reproducir vista previa' : 'Pausar vista previa');
    state.toggle.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
    update(state);
  }
  function makeDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'andrea-video-dialog';
    dialog.setAttribute('aria-labelledby', 'andrea-video-dialog-title');
    const header = document.createElement('div'); header.className = 'andrea-video-dialog__header';
    const title = document.createElement('h2'); title.id = 'andrea-video-dialog-title'; title.textContent = 'Vídeo completo';
    const close = document.createElement('button'); close.type = 'button'; close.className = 'andrea-video-dialog__close'; close.setAttribute('aria-label', 'Cerrar vídeo'); close.textContent = '×';
    header.append(title, close);
    fullVideo = document.createElement('video'); fullVideo.controls = true; fullVideo.playsInline = true; fullVideo.preload = 'none';
    fullError = document.createElement('p'); fullError.className = 'andrea-video-dialog__error'; fullError.hidden = true;
    fullLink = document.createElement('a'); fullLink.textContent = 'Abrir vídeo completo'; fullError.append(fullLink);
    dialog.append(header, fullVideo, fullError); document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    fullVideo.addEventListener('error', () => { fullError.hidden = false; });
    dialog.addEventListener('close', () => {
      fullVideo.pause(); fullVideo.removeAttribute('src'); fullVideo.removeAttribute('poster'); fullVideo.load();
      document.body.classList.remove('andrea-video-open');
      if (opener && opener.isConnected) opener.focus({preventScroll:true});
      opener = null; updateAll();
    });
  }
  function openFull(state, button) {
    makeDialog(); opener = button;
    fullVideo.pause(); fullError.hidden = true;
    fullLink.href = state.root.dataset.fullSrc;
    fullVideo.src = state.root.dataset.fullSrc;
    fullVideo.setAttribute('aria-label', state.root.dataset.videoLabel);
    const poster = state.video.getAttribute('poster');
    if (poster) fullVideo.poster = poster; else fullVideo.removeAttribute('poster');
    if (typeof dialog.showModal !== 'function') { location.assign(state.root.dataset.fullSrc); return; }
    dialog.showModal(); document.body.classList.add('andrea-video-open'); updateAll();
    const play = fullVideo.play(); if (play) play.catch(() => { /* Native controls remain available. */ });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const state = players.get(entry.target); if (!state) return; state.visible = entry.isIntersecting && entry.intersectionRatio >= .5; update(state); });
  }, {threshold:[0,.5,1],rootMargin:'0px'}) : null;
  function scan(scope = document) {
    scope.querySelectorAll('[data-andrea-video]').forEach(root => {
      if (players.has(root)) return;
      const video = root.querySelector('video'), toggle = root.querySelector('[data-video-toggle]'), open = root.querySelector('[data-video-open]');
      const state = {root, video, toggle, visible:false, userPaused:reducedMotion.matches}; players.set(root, state);
      video.muted = true; video.defaultMuted = true;
      toggle.addEventListener('click', () => { const paused = root.dataset.playback === 'manual' ? false : !state.userPaused; root.dataset.playback = ''; setPaused(state, paused); });
      open.addEventListener('click', () => openFull(state, open));
      video.addEventListener('playing', () => { root.dataset.playback = 'playing'; });
      video.addEventListener('error', () => { root.dataset.playback = 'manual'; toggle.setAttribute('aria-label','Reproducir vista previa'); toggle.firstElementChild.textContent = '▷'; });
      setPaused(state, state.userPaused);
      if (observer) observer.observe(root);
    });
  }
  window.AndreaInlineVideo = {scan};
  document.addEventListener('visibilitychange', () => { if (document.hidden && fullVideo) fullVideo.pause(); updateAll(); });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => { players.forEach((state, root) => { if (event.target.contains(root)) { state.video.pause(); if (observer) observer.unobserve(root); players.delete(root); } }); });
  reducedMotion.addEventListener('change', () => { players.forEach(state => setPaused(state, reducedMotion.matches)); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true}); else scan();
})();
